import { useSearchParams } from 'react-router'

/** The `?page=` a paginated tab is on, and a setter that drops the param on page 1. */
export function usePageParam(): [number, (page: number) => void] {
  const [searchParams, setSearchParams] = useSearchParams()
  const page = Math.max(1, Number(searchParams.get('page')) || 1)

  function setPage(next: number) {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev)
      if (next > 1) params.set('page', String(next))
      else params.delete('page')
      return params
    })
  }

  return [page, setPage]
}
